import { Button } from 'react-bootstrap';

function CustomButton({ title, variant = 'primary', onClick, icon, disabled }) {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      className='d-flex justify-content-center align-items-center'
      disabled={disabled}
    >
      <span
        className='material-symbols-outlined me-2'
        style={{ fontSize: '18px' }}
      >
        {icon}
      </span>
      {title}
    </Button>
  );
}

export default CustomButton;
